import type { SVGProps } from 'react';

export const EyeSlashSFSymbolMedium = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      height="1em"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 27.1949 21.1863"
      fill="currentColor"
      {...props}
    >
      <g>
        {' '}
        <rect height="21.1863" opacity="0" width="27.1949" x="0" y="0" />{' '}
        <path
          d="M6.28881 6.31712C3.7903 7.94644 2.2117 9.95614 2.2117 10.5998C2.2117 11.9609 7.17245 17.1781 13.4199 17.1781C14.5605 17.1781 15.6592 17.0029 16.6917 16.7056L18.2275 18.2392C16.7728 18.7476 15.1576 19.0516 13.4199 19.0516C5.52149 19.0516 0 12.5973 0 10.5998C0 9.45672 1.80272 6.86471 4.82337 4.85372ZM26.8336 10.5998C26.8336 11.7155 25.1467 14.2217 22.2593 16.2159L20.8123 14.7701C23.1556 13.2128 24.6219 11.3385 24.6219 10.5998C24.6219 9.45878 19.6434 4.02498 13.4199 4.02498C12.3935 4.02498 11.4019 4.17164 10.4664 4.43247L8.90942 2.87675C10.2914 2.42116 11.8063 2.15156 13.4199 2.15156C21.4185 2.15156 26.8336 8.59785 26.8336 10.5998ZM15.4369 15.4524C14.817 15.7112 14.1362 15.8531 13.4217 15.8531C10.5068 15.8531 8.14257 13.4881 8.14257 10.582C8.14257 9.86802 8.28443 9.18775 8.54319 8.56837ZM18.6928 10.582C18.6928 11.2007 18.5861 11.7948 18.3844 12.3441L11.6568 5.62197C12.2068 5.42084 12.8018 5.31444 13.4217 5.31444C16.3383 5.31444 18.6928 7.66894 18.6928 10.582Z"
          fill="currentColor"
        />{' '}
        <path
          d="M21.133 19.2168C21.4445 19.5283 21.9228 19.5443 22.2326 19.2168C22.5584 18.8892 22.5441 18.4287 22.2326 18.1172L5.69531 1.58965C5.3918 1.28613 4.89746 1.28613 4.58594 1.58965C4.29219 1.8834 4.29219 2.39726 4.58594 2.68925Z"
          fill="currentColor"
        />{' '}
      </g>
    </svg>
  );
};
